/**
 * Shared wire literals for the self-serve onboarding seam.
 *
 * No behaviour lives here — this module exists so every self-serve sibling
 * (the RPC schemas, their stubs, and the web wizard) imports ONE definition of
 * each literal instead of re-declaring it.
 *
 * @since 1.0.0
 */
import { IntakeInstallMode } from "@fm/db/models/Intake";
import { Schema } from "effect";

/** The two platforms self-serve onboarding can target. Parts 2 and 3 import this. */
export const SelfServePlatform = Schema.Literal("mac", "linux");
export type SelfServePlatform = Schema.Schema.Type<typeof SelfServePlatform>;

export { IntakeInstallMode };
